import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { PageHeader } from '../../../../utils/models/page-header';

import { CoreSaveService, UtilsService, MessageService, ICommonMessage, FieldType, ConfigService } from '@gbs-platform-client/fwk-core'
import { NotificationsService } from '@gbs-platform-client/building-blocks';
import { APIResponse } from 'src/app/utils/models/response';
import { takeUntil } from 'rxjs/operators';
import { forkJoin, Subject } from 'rxjs';
import { ExcelExportComponent } from '@progress/kendo-angular-excel-export';
import { Employee } from '../../models/employee';
import { EmployeeService } from '../../services/employee.service';
import { DivisionService } from '../../services/division.service';
import { Division } from '../../models/division';
import { CompanyService } from '../../services/company.service';
import { Company } from '../../models/company';
import { LocationService } from '../../services/location.service';
import { Location } from '../../models/location';
import { WorkFlow } from '../../models/workflow';
import { WorkFlowService } from '../../services/workflow.service';
import { DepartmentService } from '../../services/department.service';
import { Department } from '../../models/department';
import { MeetingtypeService } from '../../services/meetingtype.service';
import { Meetingtype } from '../../models/meetingtype';
import { Committee } from '../../models/committee';
import { CommitteeService } from '../../services/committee.service';
import { WorkFlowDetails } from '../../models/workflowdetails';
import { BasicMaster } from '../../models/basicmaster';
import { BasicMasterService } from '../../services/basicmaster.service';


@Component({
  selector: 'app-workflow',
  templateUrl: './workflow.component.html',
  styleUrls: ['./workflow.component.css']
})
export class WorkflowComponent implements OnInit {


  @ViewChild('excelexport', { static: false }) excelexport!: ExcelExportComponent;
  @ViewChild('view') view!: TemplateRef<any>;
  private unsubscribe$: Subject<void> = new Subject<void>();
  headerDepartment: PageHeader;
  entity: WorkFlow = new WorkFlow();
  selectedDepartment: WorkFlow = new WorkFlow();
  editingEntity: WorkFlow = new WorkFlow();
  MapingEntity: WorkFlow = new WorkFlow();
  Workflowdetails: WorkFlowDetails = new WorkFlowDetails();
  departments: any;
  Workflow: any;
  departmentColumns: any[] = [];
  listView: boolean = true;
  formCaption: string = '';
  employees: Array<Employee> = [];
  approvers: Array<Employee> = [];

  selectedEmployee: any;
  selectedApprover: any;

  selectedMeetingGroup: any;
  emailcheck: boolean = true;
  defaultPageSize: number;
  pageSkip: number = 0;
  ApproverCaption: string = '';
  pageSizes: any = [];
  defaultRowsCount: number;
  saveDisabled: boolean = false;
  basicmaster: Array<BasicMaster> = [];
  selectedbasic: any;
  WorkFlowDetailsarray: Array<WorkFlowDetails>;
  editWorkFlowDetailsarray: Array<WorkFlowDetails> = [];
  WorkFlowarray: any = [];
  editWorkFlowDetails_Id: any;
  deleteWorkflowDetails: any;
  //employees: Array<Employee> = [];
  WorkFlowColumns: any[] = [];
  _departments: Array<Department>;
  meetingtypes: Array<Meetingtype>;
  committee: Array<Committee>;
  opened: boolean = false;
  details: any;

  // EditCheck: boolean = false;

  constructor(
    private _departmentService: DepartmentService,
    private _employeeService: EmployeeService,
    private _divisionService: DivisionService,
    private _companyService: CompanyService,
    private _locationService: LocationService,
    private _coreSaveService: CoreSaveService,
    private configService: ConfigService,
    private messageService: MessageService,
    private notification: NotificationsService,
    private _workflowService: WorkFlowService,
    private _committeeService: CommitteeService,
    private _basicMasterService: BasicMasterService,
    private _meetingtypeService: MeetingtypeService,

  ) {
    this.headerDepartment = this.initPageHeader();
    this.defaultPageSize = Number(this.configService.getConfigValue('defaultPageSize'));
    this.pageSizes = this.configService.getConfigValue('pageSizes');
    this.defaultRowsCount = Number(this.configService.getConfigValue('defaultRowsCount'));

    this.departments = [];
    this.getAllWorkFlow();
    this._departments = [];
    this.employees = [];
    this.approvers = [];
    this.WorkFlowDetailsarray = [];
    this.meetingtypes = [];
    this.committee = [];
  }
  ngAfterViewInit(): void {
    this.departmentColumns = [
      { field: "SlNo", title: 'SL No.', filter: false, sortable: true, width: 60 },
      { field: "WorkFlowName", title: 'Work Flow', filter: true, sortable: true, width: 100 },
      { field: "WorkFlowCode", title: 'Code', filter: true, sortable: true, width: 100 },
      { field: "Active", title: 'Active', filter: false, sortable: true, width: 100 },
      { field: "", title: '', filter: true, sortable: true, width: 60, template: this.view }
    ];
    this.WorkFlowColumns = [

      { field: "EmployeeName", title: 'Approver', filter: true, sortable: true, width: 70 },
      { field: "WorkFlowTypeName", title: 'Approval Type', filter: true, sortable: true, width: 70 },
      { field: "WorkFlowOrder", title: 'Approval Order', filter: true, sortable: true, width: 70 },
      // { field: "EditBit", title: 'Edit Bit', filter: true, sortable: true, width: 70 },
    ];
  }
  onPaginationChange(event: any) {
    if (this.defaultPageSize != event.take) {
      this.defaultPageSize = event.take;
    }
    this.pageSkip = event.skip;
    this._workflowService.getAllWorkFlow('', this.defaultPageSize, ((this.pageSkip / this.defaultPageSize) + 1), 0, 0).subscribe((Workflow: Array<WorkFlow>) => {
      this.Workflow = {
        data: Workflow,
        total: Workflow[0] ? Workflow[0].TotalCount : 0
      }
    });
  }
  edituser(event: any) {
    if (event.seletedRows[0]) {
      var employee = this.entity.WorkFlowDetailsarray.filter(
        employees => employees.Emp_Ref_Id === event.seletedRows[0]);
      employee[0].EditBit = 1;
      this.editWorkFlowDetailsarray = employee;
      this.selectedEmployee = { Emp_Ref_Id: employee[0].Emp_Ref_Id, EmployeeName: employee[0].EmployeeName };
      this.selectedbasic = { DisplayValue: employee[0].WorkFlowType_Id, DisplayText: employee[0].WorkFlowTypeName };
      this.entity.WorkFlowOrder = employee[0].WorkFlowOrder;
      this.getAllEmployees('');
      this.getAllApprovers('');
      this.getAllApprovalType_type('');
      this.entity.WorkFlowDetailsarray = [];
      this.entity.WorkFlowDetailsarray = this.WorkFlowarray;
      this.entity.EditBit = 1;
    }
  }

  RemoveElementFromObjectuserArray(key: string) {
    var dataMembergrid = [... this.entity.WorkFlowDetailsarray];

    dataMembergrid.forEach((value, index) => {
      if (value.WorkFlowDetails_Id == key)
        dataMembergrid.splice(index, 1);
    });
    this.WorkFlowarray = [];
    this.WorkFlowarray = dataMembergrid;


  };

  getval() {
    var data = [... this.WorkFlowarray];
    if (this.Workflowdetails.Emp_Ref_Id == '00000000-0000-0000-0000-000000000000' || this.Workflowdetails.Emp_Ref_Id == "" || this.Workflowdetails.Emp_Ref_Id == undefined) {
      this.notification.showWarning('Please select Approver');
      return;
    }
    if (this.Workflowdetails.WorkFlowType_Id === 0) {
      this.notification.showWarning('Please select approval type');
      return;
    }
    if (this.entity.WorkFlowOrder == 0) {
      this.notification.showWarning('Please enter valid approval order');
      return;
    }
    // if (this.entity.WorkFlowOrder != 0 && this.entity.WorkFlowDetailsarray.length > 0&&this.entity.EditBit==0) {
    //   if (this.entity.WorkFlowOrder < this.entity.WorkFlowDetailsarray[this.entity.WorkFlowDetailsarray.length-1].WorkFlowOrder||(Number(this.entity.WorkFlowOrder)>Number(this.entity.WorkFlowDetailsarray[this.entity.WorkFlowDetailsarray.length-1].WorkFlowOrder)+1)) {
    //     this.notification.showWarning('Please enter valid approval order');
    //     return;
    //   }
    // }
    // if(Number(this.entity.WorkFlowOrder)>1&&this.entity.WorkFlowDetailsarray.length == 0){
    //   this.notification.showWarning('Please enter valid approval order');
    //   return;
    // }
    if (this.Workflowdetails.Emp_Ref_Id != '00000000-0000-0000-0000-000000000000' && this.Workflowdetails.Emp_Ref_Id != "" &&
      this.Workflowdetails.WorkFlowType_Id != 0 && this.entity.WorkFlowOrder != 0) {
      var employeeCheck = this.entity.WorkFlowDetailsarray.filter(
        WorkFlowDetailsarray =>
          WorkFlowDetailsarray.EditBit === 1);
      if (employeeCheck.length == 1) {
        var editemployee = this.editWorkFlowDetailsarray.filter(
          editemployees => editemployees.EditBit === 1);

        var editemp = this.entity.WorkFlowDetailsarray.filter(
          editemps => editemps.Emp_Ref_Id === this.Workflowdetails.Emp_Ref_Id && editemps.EditBit != 1);
        if (editemp.length > 0) {
          this.notification.showWarning('User Already Exists');
        }
        else {
          var BAsictype = this.basicmaster.filter(
            basicmaster => basicmaster.DisplayValue === this.Workflowdetails.WorkFlowType_Id);
          editemployee[0].WorkFlowType_Id = BAsictype[0].DisplayValue;
          editemployee[0].WorkFlowTypeName = BAsictype[0].DisplayText;
          editemployee[0].WorkFlowOrder = this.entity.WorkFlowOrder;
          if (this.selectedApprover === null || this.selectedApprover === undefined) {
            editemployee[0].Emp_Ref_Id = this.selectedEmployee != undefined ? this.selectedEmployee?.Emp_Ref_Id : "";
            editemployee[0].EmployeeName = this.selectedEmployee != undefined ? this.selectedEmployee?.EmployeeName : "";
          }
          else {
            editemployee[0].Emp_Ref_Id = this.selectedApprover != undefined ? this.selectedApprover?.Emp_Ref_Id : "";
            editemployee[0].EmployeeName = this.selectedApprover != undefined ? this.selectedApprover?.EmployeeName : "";
          }
          editemployee[0].WorkFlowDetails_Id = this.editWorkFlowDetails_Id;
          editemployee[0].MeetingType_id = this.entity.MeetingType_Id;
          editemployee[0].EditBit = 0;
          this.entity.EditBit = 0;
          this.editWorkFlowDetailsarray = [];
          this.Workflowdetails = new WorkFlowDetails();
          this.selectedEmployee = [];
          this.entity.WorkFlowOrder = 0;
          this.selectedApprover = null;
        }

      }
      else if (employeeCheck.length == 0) {

        var editemp = this.entity.WorkFlowDetailsarray.filter(
          editemps => editemps.Emp_Ref_Id === this.Workflowdetails.Emp_Ref_Id && editemps.EditBit != 1);
        if (editemp.length > 0) {
          this.notification.showWarning('User Already Exists');
        }
        else {
          // var editemployee = this.editWorkFlowDetailsarray.filter(
          //   editemployees => editemployees.Emp_Ref_Id === this.Workflowdetails.Emp_Ref_Id);
          // if (editemployee.length > 0) {
          //   this.editWorkFlowDetails_Id = editemployee[0].WorkFlowDetails_Id
          // }
          var BAsictype = this.basicmaster.filter(
            basicmaster => basicmaster.DisplayValue === this.Workflowdetails.WorkFlowType_Id);

          data.push({
            Emp_Ref_Id: this.selectedApprover?.Emp_Ref_Id,
            EmployeeName: this.selectedApprover?.EmployeeName,
            WorkFlowType_Id: BAsictype[0].DisplayValue,
            WorkFlowTypeName: BAsictype[0].DisplayText,
            WorkFlowOrder: this.entity.WorkFlowOrder,
            WorkFlowDetails_Id: this.editWorkFlowDetails_Id,
            MeetingType_id: this.entity.MeetingType_Id
          });
          this.WorkFlowarray = data;
          this.entity.WorkFlowDetailsarray = this.WorkFlowarray;
          this.editWorkFlowDetailsarray = [];
          this.Workflowdetails = new WorkFlowDetails();
          this.selectedEmployee = [];
          this.entity.WorkFlowOrder = 0;
          this.selectedApprover = null;
        }
      }

      // else {
      //   this.notification.showWarning(' User Already Exists');
      // }
    }
  };
  onFilterChange(event: any): void {
    if (((event && event.filter && event.filter.filters[0] && event.filter.filters[0].filters[0]) != null)) {
      var filter = (event.filter.filters[0].filters[0].field + '|' + event.filter.filters[0].filters[0].value + ';');
      //1 for gridfilter type
      this._workflowService.getAllWorkFlow(filter, this.defaultPageSize, ((this.pageSkip / this.defaultPageSize) + 1), 1, 0).subscribe((Workflow: Array<WorkFlow>) => {
        this.Workflow = {
          data: Workflow,
          total: Workflow[0] ? Workflow[0].TotalCount : 0
        }
      });
    }
  }
  getAllDepartment(filter: string) {
    if (filter) {
      this._departmentService.getAllDepartment(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<Department>) => {
        this._departments = data;
        return this._departments;
      })
    }
    else {
      this._departmentService.getAllDepartment('', this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<Department>) => {
        this._departments = data;
        return this._departments;
      })
    }
  }

  getAllMeetingType(filter: string) {
    this._meetingtypeService.getAllMeetingtype(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<Meetingtype>) => {
      this.meetingtypes = data;
    })
  }
  getAllCommittee(filter: string) {
    if (filter) {
      this._committeeService.getAllCommittee(filter, this.defaultRowsCount, 1, 2, this.entity.MeetingType_Id).subscribe((data: Array<Committee>) => {
        this.committee = data;
        return this.committee;
      })
    }
    else {
      this._committeeService.getAllCommittee('', this.defaultRowsCount, 1, 2, this.entity.MeetingType_Id).subscribe((data: Array<Committee>) => {
        this.committee = data;
        return this.committee;
      })
    }
  }

  getAllWorkFlow() {
    this._workflowService.getAllWorkFlow('', Number(this.defaultPageSize), 1, 0, 0).subscribe((Workflow: Array<WorkFlow>) => {
      // alert(Workflow);
      this.Workflow = {
        data: Workflow,
        total: Workflow[0] ? Workflow[0].TotalCount : 0
      }
      // this.Workflow = Workflow;
    })
  }
  ngOnInit(): void {
    this.getAllCommittee('');
    this.getAllApprovers('');
    this.getAllMeetingType('');
    this.messageService.activeCommonMessage.pipe(takeUntil(this.unsubscribe$)).subscribe((message: ICommonMessage | null) => {
      if (message?.eventName === 'delete_read_confirmation') {
        if (message?.param.action === "FA") {
          this._workflowService.deleteWorkFlow(this.selectedDepartment.WorkFlow_Id).subscribe((entity: any) => {
            this.notification.showSuccess('Deleted Successfully');
            this.clearEntity();
            this.getAllWorkFlow();
          },
          )
        }
      }
      if (message?.eventName === 'WfD') {
        if (message?.param.action === 'FA') {
          var employee = this.entity.WorkFlowDetailsarray.filter(
            employees => employees.Emp_Ref_Id === this.deleteWorkflowDetails);
          var workdetailid = employee[0].WorkFlowDetails_Id;
          this.deleteworkdetails(workdetailid);
          this.RemoveElementFromObjectuserArray(workdetailid);
          this.entity.WorkFlowDetailsarray = [];
          this.entity.WorkFlowDetailsarray = this.WorkFlowarray;

        }
      }

    });
  }

  deleteworkdetails(WorkFlowDetailsId: string) {
    this._workflowService.deleteWorkFlowDetails(WorkFlowDetailsId).subscribe((entity: any) => {
      // this.notification.showSuccess('Deleted Successfully');

    });
  }
  getAllEmployees(filter: string) {
    this._employeeService.getAllEmployees(filter, this.defaultRowsCount, 1, 0, 1).subscribe((employees: Array<Employee>) => {
      this.employees = employees;
    })
  };

  getAllApprovers(filter: string) {
    this._workflowService.getAllApprovers(filter, this.defaultRowsCount, 1, 0, 1).subscribe((approvers: Array<Employee>) => {
      this.approvers = approvers;
    })
  };

  setApproverEmployee(employee: any): void {
    this.selectedApprover = employee;
  };

  // setApprover (approvers: any) {
  //     this.selectedEmployee = approvers;
  // };

  initPageHeader(): PageHeader {
    let headerDepartment = new PageHeader();
    headerDepartment.PageCaption = "Work Flow";
    headerDepartment.IconClass = "bi bi-shield-shaded";
    return headerDepartment;
  }

  deleteDepartment(event: any) {
    if (event.seletedRows[0]) {
      this.selectedDepartment.WorkFlow_Id = event.seletedRows[0];
      var message: ICommonMessage = {
        eventName: "showDialog",
        param: {
          content: "Do you want to delete this entry ?",
          caption: "WorkFlow",
          returnKey: "delete_read_confirmation"
        }
      };
      this.messageService.sendCommonMessage(message);
    }
  }
  deleteuser(event: any) {

    if (event.seletedRows[0]) {
      this.deleteWorkflowDetails = event.seletedRows[0];
      var message: ICommonMessage = {
        eventName: "showDialog",
        param: {
          content: "Do you want to delete this entry ?",
          caption: "WorkFlow",
          returnKey: "WfD",
          Key: event.seletedRows[0]
        }
      };
      this.messageService.sendCommonMessage(message);
      //  var employee = this.entity.WorkFlowDetailsarray.filter(
      // employees => employees.Emp_Ref_Id === event.seletedRows[0]);
      // var workdetailid=employee[0].WorkFlowDetails_Id;
      // this.deleteworkdetails(workdetailid);
      // this.RemoveElementFromObjectuserArray(workdetailid);
      // this.entity.WorkFlowDetailsarray = [];
      // this.entity.WorkFlowDetailsarray = this.WorkFlowarray;
    }
  }

  addDepartment(event: any) {
    this.listView = false;
    this.clearEntity();
    this.getAllDepartment('');
    this.getAllMeetingType('');
    this.getAllCommittee('');
    this.getAllEmployees('');
    this.getAllApprovalType_type('');
    this.formCaption = "Add Work Flow";
  }
  getAllApprovalType_type(filter: string) {
    this._basicMasterService.getBasicMastersByName('ApprovalType', filter, this.defaultRowsCount, 1).subscribe((data: Array<BasicMaster>) => {
      this.basicmaster = data;
    })
  }
  editWorkflow(event: any): void {
    if (event.seletedRows[0]) {
      // this._workflowService.viewWorkFlow(event.seletedRows[0]).subscribe((departments: Array<WorkFlow>) => {
      //   let editEnity = departments;
      this._workflowService.viewWorkFlow(event.seletedRows[0]).subscribe((departments: any) => {
        let editEnity = departments;
        if (editEnity) {
          this.editingEntity = editEnity;
          this.entity = { ...this.editingEntity };
          this.listView = false;
          this.formCaption = "Edit Work Flow";
          this.getAllDepartment('');
          this.entity.departments = this.editingEntity.departments;
          this.selectedMeetingGroup = { MeetingType_Id: editEnity.MeetingType_Id, MeetingTypeName: editEnity.MeetingTypeName };
          this.getAllMeetingType('');
          this.getAllCommittee('');
          this.WorkFlowarray = this.editingEntity.WorkFlowDetailsarray;
          this.entity.WorkFlowDetailsarray = this.editingEntity.WorkFlowDetailsarray;
          this.getAllEmployees('');
          this.getAllApprovers('');
          this.getAllApprovalType_type('');
          this.entity.EntityMetaData = [
            { FieldName: 'WorkFlowName', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: ' WorkFlow is required' },
            //{ FieldName: 'Location_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Location is required' },
            { FieldName: 'WorkFlowCode', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'WorkFlow Code is required' },
            { FieldName: 'MeetingType_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Meeting Group is required' }

          ];
        }
      });
    }
  }

  save(event: any): void {
    this.saveDisabled = true;
    let validations = this._coreSaveService.saveValidation(this.entity);
    if (validations.length === 0) {
      this._workflowService.checkDuplication(this.entity.WorkFlowCode, this.entity.WorkFlow_Id).subscribe((res) => {
        if (res.Success === false) {
          this.notification.showWarning('WorkFlow Code already exists');
          this.saveDisabled = false;
          return
        }
        if (this.entity.WorkFlowDetailsarray.length == 0) {
          this.notification.showWarning('Please Enter Approver Details');
          this.saveDisabled = false;
          return

        }
        if (this.entity.departments.length == 0) {
          this.notification.showWarning('Department is required');
          this.saveDisabled = false;
        }
        else {
          console.log(this.entity)
          this._workflowService.saveWorkFlow(this.entity).subscribe(() => {
            if (this.entity.WorkFlow_Id == '00000000-0000-0000-0000-000000000000') {
              this.notification.showSuccess('Saved Successfully');
            }
            else {
              this.notification.showSuccess('Updated Successfully');
            }
            this.listView = true;
            this.clearEntity();
            this.getAllWorkFlow();
          })
        }
      });
    }
    else {
      this.saveDisabled = false;
    }
  }
  goToBackTab(): void {
    this.listView = true;
    this.selectedEmployee = {}
  }
  AlphabetsOnly(event: any): boolean {
    var inp = String.fromCharCode(event.keyCode);
    if (/^[a-zA-Z\s]*$/.test(inp)) {
      return true;
    } else {
      return false;
    }

  }

  gotoBack(): void {
    this.listView = true;
    this.getAllDepartment('');
  }

  refreshDepartments(event: any): void {
    // this.departments = [];
    // this.getAllDepartment('');
    this.getAllWorkFlow();
  }

  clearEntity(): void {
    this.entity = new WorkFlow();
    this.Workflowdetails = new WorkFlowDetails();
    this.saveDisabled = false;
    this.departments = [];
    this.getAllWorkFlow();
    this._departments = [];
    this.employees = [];
    this.entity.WorkFlowDetailsarray = [];
    this.editWorkFlowDetailsarray = [];
    this.meetingtypes = [];
    this.committee = [];
    this.WorkFlowarray = [];
    this.editWorkFlowDetailsarray = [];
    this.Workflowdetails = new WorkFlowDetails();
    this.selectedEmployee = [];
    this.entity.WorkFlowOrder = 0;
    this.selectedMeetingGroup = [];
  }

  onExcelExport() {
    this.excelexport.save()
  }

  revertChanges(): void {
    this.entity = { ...this.editingEntity };
  }

  numberOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
  public close() {
    this.opened = false;
  }
  public open(dataItem: any): void {
    this.entity.WorkFlow_Id = dataItem.WorkFlow_Id;
    this.details = [];
    this._workflowService.viewWorkFlow(this.entity.WorkFlow_Id).subscribe((data: any) => {
      this.opened = true;
      this.details = data;
      this.ApproverCaption = 'Approver Details';
      // console.log(data)
      // console.log(data[0].WorkFlowDetailsarray)


    })
  }
}

